/* eslint-disable react-hooks/exhaustive-deps */
import {useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import SelectRange, {FIELD_NAME} from '@adv-mt/mt-form-select-range'

const LEGACY_WRAPPER = 'legacy'

const FormSeatsRange = ({
  initialSearch,
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  value = {},
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {seats, DEFAULT_SEATS_MIN = 0, FILTER_NAMES} = config.get('search')

  const currentValue = {
    from: value.from || DEFAULT_SEATS_MIN,
    to: value.to || DEFAULT_SEATS_MIN
  }

  const options = useMemo(
    () =>
      seats.map(({id, label}) => ({
        id: Number(id),
        label: `${label} ${i18n.t('COMMON.SEATS').toLowerCase()}`
      })),
    []
  )

  return (
    <SelectRange
      fieldName={FILTER_NAMES.SEAT}
      formatterLabel={({value}) => `${value} ${i18n.t('COMMON.SEATS').toLowerCase()}`}
      initialSearch={initialSearch}
      label={i18n.t('COMMON.SEATS')}
      onChange={onChange}
      options={{
        from: {
          name: FIELD_NAME.FROM,
          options
        },
        to: {
          name: FIELD_NAME.TO,
          options
        }
      }}
      overlayContentRef={overlayContentRef}
      pageName={pageName}
      type={type}
      value={currentValue}
      wrapper={wrapper}
    />
  )
}

FormSeatsRange.displayName = 'FormSeatsRange'
FormSeatsRange.propTypes = {
  initialSearch: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.object,
  wrapper: PropTypes.string
}

export default FormSeatsRange
